import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cell-plug-comment",
  "use": "icon-cell-plug-comment-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-cell-plug-comment\"><rect x=\"6\" y=\"6\" width=\"12\" height=\"10\" rx=\"2\" stroke=\"currentColor\" stroke-width=\"2\" /><path d=\"M12 9v4M14 11h-4\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /><path d=\"m18 16-3.671-.612A2 2 0 0 0 12 17.361v2.225c0 .89 1.077 1.337 1.707.707L18 16Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol